import { SvgIcon, SvgIconProps } from "@mui/material";

const ShieldPerson = (props: SvgIconProps) => (
  <SvgIcon
    width={props.width || "24px"}
    height={props.height || "24px"}
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="mask0_4473_33792"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill={props.fill || "currentColor"} />
    </mask>
    <g mask="url(#mask0_4473_33792)">
      <path
        d="M12 12.75C11.0872 12.75 10.3173 12.4365 9.6905 11.8095C9.0635 11.1827 8.75 10.4128 8.75 9.50001C8.75 8.58718 9.0635 7.81735 9.6905 7.19051C10.3173 6.56351 11.0872 6.25001 12 6.25001C12.9128 6.25001 13.6827 6.56351 14.3095 7.19051C14.9365 7.81735 15.25 8.58718 15.25 9.50001C15.25 10.4128 14.9365 11.1827 14.3095 11.8095C13.6827 12.4365 12.9128 12.75 12 12.75ZM12 11.25C12.4975 11.25 12.9135 11.0827 13.248 10.748C13.5827 10.4135 13.75 9.99751 13.75 9.50001C13.75 9.00251 13.5827 8.58651 13.248 8.25201C12.9135 7.91735 12.4975 7.75001 12 7.75001C11.5025 7.75001 11.0865 7.91735 10.752 8.25201C10.4173 8.58651 10.25 9.00251 10.25 9.50001C10.25 9.99751 10.4173 10.4135 10.752 10.748C11.0865 11.0827 11.5025 11.25 12 11.25ZM12 21.4808C9.83717 20.8909 8.0465 19.6178 6.628 17.6615C5.20933 15.7052 4.5 13.518 4.5 11.1V5.34626L12 2.53851L19.5 5.34626V11.1C19.5 13.518 18.7907 15.7052 17.372 17.6615C15.9535 19.6178 14.1628 20.8909 12 21.4808ZM12 4.13451L6 6.37501V11.1C6 12.0513 6.13625 12.9713 6.40875 13.8598C6.68108 14.7481 7.05958 15.5769 7.54425 16.3463C8.21858 16.0026 8.92467 15.734 9.6625 15.5405C10.4003 15.3468 11.1795 15.25 12 15.25C12.8205 15.25 13.5997 15.3468 14.3375 15.5405C15.0753 15.734 15.7814 16.0026 16.4557 16.3463C16.9404 15.5769 17.3189 14.7481 17.5913 13.8598C17.8638 12.9713 18 12.0513 18 11.1V6.37501L12 4.13451ZM12 16.75C11.3552 16.75 10.735 16.8198 10.1395 16.9595C9.544 17.0993 8.9815 17.2955 8.452 17.548C8.94817 18.0993 9.494 18.576 10.0895 18.978C10.685 19.3798 11.3218 19.6872 12 19.9C12.6782 19.6872 13.3134 19.3798 13.9057 18.978C14.4981 18.576 15.0423 18.0993 15.5385 17.548C15.009 17.2955 14.4481 17.0993 13.8558 16.9595C13.2634 16.8198 12.6448 16.75 12 16.75Z"
        fill={props.fill || "currentColor"}
      />
    </g>
  </SvgIcon>
);
export default ShieldPerson;
